import defaultColor from "@/components/color";
const dataText = JSON.stringify([
    {
        data: {fang:35000,kill:50000,life:18000,li:4200,speed:12000,gong:20000},
        group: '张三'
    },
    {
        data: {li:5200,speed:3100,gong:22000,fang:36000,kill:51000,life:12000},
        group: '李四'
    }
])
export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0, dataText: dataText,
    },
    attribute:{
        colors:defaultColor,
        title: {
            text: '',
            //subtext: '纯属虚构',
            left: 'left',
            top: 'top',
            textStyle:{
                fontSize:18,
                color: '#fff'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        legend:{
            show:true,
            right:10,
            top:0,
            orient:'vertical',
            textStyle: {
                color:'#6aa9e4',
                fontSize: 14
            }
        },
        radar: {
            axisName: {
                color: '#ddd',
                fontSize:14,
            },
            shape:'polygon',
            indicator:[
                { name: '力量', max: 6500, key:'li' },
                { name: '速度', max: 16000, key:'speed' },
                { name: '攻击', max: 30000, key:'gong' },
                { name: '防御', max: 38000, key:'fang' },
                { name: '伤害', max: 52000, key:'kill' },
                { name: '生命', max: 25000, key:'life' }
            ],
            splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
                show: false,
                areaStyle: { //分隔区域的样式设置。
                    // color: ['rgba(0,196,255,0.1)', 'rgba(0,112,176,0.1)'],
                    color: ['#6aa9e4', '#6aa9e4']
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#6aa9e4',
                }
            },
            axisLine: { // (圆内的几条直线)坐标轴轴线相关设置
                lineStyle: {
                    color: '#6aa9e4',
                    // 坐标轴线线的颜色。
                    width: 1,
                    // 坐标轴线线宽。
                    type: 'solid',
                    // 坐标轴线线的类型。
                }
            },
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            },
          
        },
        cptTableData: [{ "name": "分组", "value": "", "namekey": "group" },
        { "name": "维度", "value": "", "namekey": "name" },
        { "name": "指标", "value": "", "namekey": "value" }]
    },
}
